export const dashboardRouteName = {
  index: "dashboard.index",
};

export const dashboardRoute = [
  {
    path: "/dashboard",
    name: dashboardRouteName.index,
    component: () => import("../pages/DashboardPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "dashboard",
      breadcrumbs: () => {
        return [
          {
            title: "Dashboard",
          },
        ];
      },
    },
  },
];
